import React, { useState } from 'react';
import './ScheduleInterview.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ScheduleInterview = () => {
  const [currentCandidate, setCurrentCandidate] = useState('');
  const [panelMembers, setPanelMembers] = useState([
    { initials: 'PS', name: 'Priya Sharma', role: 'HR Manager · Lead Recruiter', color: '#EC4119', status: 'free' },
    { initials: 'RD', name: 'Rahul Dev', role: 'Tech Lead · Engineering', color: '#0891b2', status: 'busy' },
  ]);
  const [reminders, setReminders] = useState(2);
  const [endTime, setEndTime] = useState('12:00 PM');

  const updateCandInfo = (e) => {
    const val = e.target.value;
    setCurrentCandidate(val);
    // Simulate candidate info update
  };

  const addPanel = () => {
    const sel = document.getElementById('newPanelSel');
    if (!sel || !sel.value) return;
    const parts = sel.value.split('|');
    const newMember = {
      initials: parts[0],
      name: parts[1],
      role: parts[2],
      color: parts[3],
      status: 'free',
    };
    setPanelMembers([...panelMembers, newMember]);
    sel.value = '';
    toast(`${newMember.name} added to panel`);
  };

  const removePanel = (index) => {
    setPanelMembers(panelMembers.filter((_, i) => i !== index));
  };

  const addReminder = () => {
    setReminders(prev => prev + 1);
    toast('New reminder added');
  };

  const removeReminder = (index) => {
    // Logic for removing specific reminder
    toast('Reminder removed');
  };

  const calcEndTime = () => {
    const time = document.getElementById('intTime')?.value;
    const dur = document.getElementById('intDur')?.value;
    if (!time) return;
    // Simple time calculation (you can improve it)
    setEndTime('12:00 PM');
  };

  const selectMode = (el, mode) => {
    document.querySelectorAll('.mode-opt').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
  };

  const generateLink = () => {
    const linkInput = document.getElementById('meetLink');
    if (linkInput) {
      linkInput.value = `https://meet.google.com/abc-defg-${Math.random().toString(36).substr(2, 4)}`;
      toast('Google Meet link generated');
    }
  };

  const submitSched = () => {
    toast('Interview scheduled — invites sent to candidate and all panel members');
    setTimeout(() => {
      window.location.href = 'recruitment-interviews.html';
    }, 1800);
  };

  const toast = (msg, type = 'success') => {
    const t = document.createElement('div');
    t.className = 'og-toast';
    const color = type === 'warn' ? '#fbbf24' : '#4ade80';
    t.innerHTML = `<i class="fa-solid fa-check-circle" style="color:${color};"></i>${msg}`;
    document.body.appendChild(t);
    setTimeout(() => {
      t.style.opacity = '0';
      setTimeout(() => t.remove(), 300);
    }, 2800);
  };

  return (
    <>
      
<div className="topbar">
          <i className="fa-solid fa-calendar-plus" style={{ color: 'var(--primary)' }}></i>
          <div className="breadcrumb" style={{ margin: '0' }}>
            <a href="recruitment-interviews.html">Interviews</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: '.6rem' }}></i>
            <strong style={{ color: 'var(--text)' }}>Schedule Interview</strong>
          </div>
          <div className="top-right">
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <div className="top-avatar">AM</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '.8rem' }}>Arun Mishra</div>
                <div style={{ fontSize: '.68rem', color: 'var(--muted)' }}>HR Admin</div>
              </div>
            </div>
          </div>
        </div>
      <div className="container-fluid position-relation">
        

        <div className="page-hd">
            <div className="Page-head">
               <div className='leftside-head'>
              <h2>
                <i className="fa-solid fa-calendar-plus" style={{ color: 'var(--primary)', marginRight: '.4rem', fontSize: '1.1rem' }}></i>
                Schedule Interview
              </h2>
              <div className="breadcrumb">Set up an interview round with panel and reminders</div>
            </div>
            <Link to="/Recruitment/Reimbursement-Dadhboard" className="btn btn-outline btn-sm btn-gray">
              <i className="fa-solid fa-arrow-left"></i> Back
            </Link>
            </div>
          </div>

          <div className="sched-layout">

  {/* Left: Form */}
  <div>

    {/* Candidate & Job */}
    <div className="fs-bx">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-user-tie"></i>
        <h4>Candidate &amp; Job</h4>
      </div>

      <div className="fs-body">

        <div className="form-row form-row-1">

          <div className="fg">

            <label>
              Candidate <span className="req">*</span>
            </label>

            <select
              className="og-select"
              id="candSel"
              onChange={() => updateCandInfo()}
            >
              <option value="">
                Search and select candidate…
              </option>

              <option value="RK">
                Rahul Kumar — 5 yrs · Delhi · React, TypeScript
              </option>

              <option value="PS">
                Priya Singh — 4 yrs · Noida · Vue, React
              </option>

              <option value="AK">
                Amit Kumar — 3 yrs · Gurgaon · React, CSS
              </option>

              <option value="MJ">
                Meera Joshi — 4 yrs · Bengaluru · React, Node.js
              </option>

              <option value="SR">
                Siddharth Rao — 5 yrs · Bengaluru · React, TypeScript
              </option>
            </select>

            <div id="candInfo" className="cand-info"></div>

          </div>
        </div>


        <div className="form-row form-row-1">

          <div className="fg">

            <label>
              Job <span className="req">*</span>
            </label>

            <select className="og-select">

              <option value="">
                Select job…
              </option>

              <option value="JOB-2026-001" defaultValue>
                JOB-2026-001 — Senior Frontend Developer
              </option>

              <option>
                JOB-2026-002 — Product Manager
              </option>

              <option>
                JOB-2026-004 — Data Analyst
              </option>

              <option>
                JOB-2026-005 — Senior Backend Engineer
              </option>

            </select>

          </div>
        </div>


        <div className="form-row form-row-2">

          <div className="fg">

            <label>
              Round Name <span className="req">*</span>
            </label>

            <input
              className="og-input"
              id="roundName"
              placeholder="e.g. Round 1 — Technical Screening"
            />

          </div>

          <div className="fg">

            <label>Round Number</label>

            <select className="og-select">
              <option>Round 1</option>
              <option defaultValue>Round 2</option>
              <option>Round 3</option>
              <option>Round 4</option>
              <option>Final Round</option>
            </select>

          </div>

        </div>

      </div>
    </div>


    {/* Date, Time & Duration */}
    <div className="fs-bx">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-clock"></i>
        <h4>Date, Time &amp; Duration</h4>
      </div>

      <div className="fs-body">

        <div className="form-row form-row-3">

          <div className="fg">

            <label>
              Date <span className="req">*</span>
            </label>

            <input
              type="date"
              className="og-input"
              id="intDate"
             
            />

          </div>


          <div className="fg">

            <label>
              Start Time <span className="req">*</span>
            </label>

            <input
              type="time"
              className="og-input"
              id="intTime"
              defaultValue="11:00"
             
            />

          </div>


          <div className="fg">

            <label>
              Duration <span className="req">*</span>
            </label>

            <select
              className="og-select"
              id="intDur"
             
            >
              <option>30 minutes</option>
              <option>45 minutes</option>
              <option defaultValue>60 minutes</option>
              <option>90 minutes</option>
              <option>120 minutes</option>
            </select>

          </div>

        </div>


        <div id="endTime" className="end-time">

          <i className="fa-regular fa-clock"></i>

          Interview ends at:{" "}

          <strong id="endTimeVal">
            12:00 PM
          </strong>

        </div>

      </div>
    </div>


    {/* Interview Mode */}
    <div className="fs-bx">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-video"></i>
        <h4>Interview Mode</h4>
      </div>

      <div className="fs-body">

        <div className="mode-opts">

          <div
            className="mode-opt selected"
            onClick={(e) =>
              selectMode(e.currentTarget, "Video Call")
            }
          >
            <input
              type="radio"
              name="mode"
              defaultChecked
            />

            <div className="mode-icon">📹</div>
            <div className="mode-label">Video Call</div>
          </div>


          <div
            className="mode-opt"
            onClick={(e) =>
              selectMode(e.currentTarget, "In-person")
            }
          >
            <input
              type="radio"
              name="mode"
            />

            <div className="mode-icon">🏢</div>
            <div className="mode-label">In-person</div>
          </div>


          <div
            className="mode-opt"
            onClick={(e) =>
              selectMode(e.currentTarget, "Phone Call")
            }
          >
            <input
              type="radio"
              name="mode"
            />

            <div className="mode-icon">📞</div>
            <div className="mode-label">Phone Call</div>
          </div>

        </div>


        <div className="fg mode-field" id="linkField">

          <label>Meeting Link</label>

          <div className="meeting-link-row">

            <input
              className="og-input"
              id="meetLink"
              placeholder="https://meet.google.com/…"
            />

            <button
              className="btn btn-outline btn-sm"
              onClick={() => generateLink()}
            >
              <i className="fa-brands fa-google"></i>
              Generate
            </button>

          </div>

        </div>

      </div>
    </div>


    {/* Reminders */}
    <div className="fs-bx">

      <div className="fs-head">

        <i className="fs-icon fa-solid fa-bell"></i>

        <h4>Reminders</h4>

        <button
          className="btn btn-outline btn-xs add-reminder-btn"
          onClick={() => addReminder()}
        >
          <i className="fa-solid fa-plus"></i>
          Add Reminder
        </button>

      </div>

      <div className="fs-body">

        <div id="reminderList">

          <div className="reminder-row">

            <i className="fa-solid fa-bell reminder-icon-amber"></i>

            <span className="rr-label">
              24 hours before
            </span>

            <select className="og-select reminder-select">
              <option defaultValue>Email</option>
              <option>Email + In-app</option>
              <option>In-app only</option>
            </select>

            <select className="og-select reminder-recipient">
              <option>Candidate</option>
              <option>Panel only</option>
              <option>All</option>
            </select>

            <button
              className="rr-remove"
              onClick={(e) =>
                removeReminder(e.currentTarget)
              }
            >
              <i className="fa-solid fa-times reminder-remove-icon"></i>
            </button>

          </div>


          <div className="reminder-row">

            <i className="fa-solid fa-bell reminder-icon-primary"></i>

            <span className="rr-label">
              1 hour before
            </span>

            <select className="og-select reminder-select">
              <option>Email</option>
              <option defaultValue>
                Email + In-app
              </option>
              <option>In-app only</option>
            </select>

            <select className="og-select reminder-recipient">
              <option defaultValue>Candidate</option>
              <option>Panel only</option>
              <option>All</option>
            </select>

            <button
              className="rr-remove"
              onClick={(e) =>
                removeReminder(e.currentTarget)
              }
            >
              <i className="fa-solid fa-times reminder-remove-icon"></i>
            </button>

          </div>

        </div>

        <div className="reminder-note">
          Reminders are sent to selected recipients before the interview.
        </div>

      </div>
    </div>


    {/* Additional Notes */}
    <div className="fs-bx">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-note-sticky"></i>
        <h4>Additional Notes</h4>
      </div>

      <div className="fs-body">

        <div className="fg">

          <label>
            Instructions for Candidate{" "}
            <span className="note-label-info">
              (included in invite email)
            </span>
          </label>

          <textarea
            className="og-textarea"
            rows="3"
            placeholder="e.g. Please be ready 5 min early. Have your portfolio link ready. You may be asked to share screen for a live coding task."
          ></textarea>

        </div>


        <div className="fg">

          <label>
            Instructions for Panel{" "}
            <span className="note-label-info">
              (internal only)
            </span>
          </label>

          <textarea
            className="og-textarea"
            rows="2"
            placeholder="e.g. Focus on TypeScript depth. Ask about state management approach. Previous round notes in candidate profile."
          ></textarea>

        </div>

      </div>
    </div>

  </div>


  {/* Right: Panel management + context */}
  <div className="sched-sidebar">

    {/* Interview Panel */}
    <div className="side-card">

      <div className="side-card-header">

        <h4>
          <i className="fa-solid fa-users side-header-icon-primary"></i>
          Interview Panel
        </h4>

        <span
          id="panelCount"
          className="panel-count"
        >
          2 members
        </span>

      </div>


      <div className="panel-body">

        <div id="panelList">

          <div className="panel-member">

            <div className="pm-av pm-av-priya">
              PS
            </div>

            <div className="pm-info">
              <div className="pm-name">
                Priya Sharma
              </div>

              <div className="pm-role">
                HR Manager · Lead Recruiter
              </div>
            </div>

            <span className="pm-avail free">
              <i className="fa-solid fa-circle pm-status-icon"></i>
              Free
            </span>

            <button
              className="pm-remove"
              onClick={(e) =>
                removePanel(e.currentTarget)
              }
            >
              <i className="fa-solid fa-times panel-remove-icon"></i>
            </button>

          </div>


          <div className="panel-member">

            <div className="pm-av pm-av-rahul">
              RD
            </div>

            <div className="pm-info">
              <div className="pm-name">
                Rahul Dev
              </div>

              <div className="pm-role">
                Tech Lead · Engineering
              </div>
            </div>

            <span className="pm-avail busy">
              <i className="fa-solid fa-circle pm-status-icon"></i>
              Busy 10–11AM
            </span>

            <button
              className="pm-remove"
              onClick={(e) =>
                removePanel(e.currentTarget)
              }
            >
              <i className="fa-solid fa-times panel-remove-icon"></i>
            </button>

          </div>

        </div>


        <div
          id="conflictWarn"
          className="conflict-warn"
        >
          <i className="fa-solid fa-triangle-exclamation"></i>

          <span>
            Rahul Dev has a conflict at 10–11 AM.
            Consider a different time or replace the panel member.
          </span>
        </div>


        {/* Add Panel Member */}
        <div className="add-panel-box">

          <div className="add-panel-label">
            Add Panel Member
          </div>

          <div className="add-panel-row">

            <select
              className="og-select add-panel-select"
              id="newPanelSel"
            >
              <option value="">
                Select employee…
              </option>

              <option value="AM|Arun Mishra|HR Admin|#16a34a">
                Arun Mishra — HR Admin
              </option>

              <option value="NG|Neha Gupta|Product Manager|#7c3aed">
                Neha Gupta — Product Manager
              </option>

              <option value="VK|Vikram Kumar|Backend Lead|#d97706">
                Vikram Kumar — Backend Lead
              </option>

              <option value="SP|Shruti Pillai|Design Lead|#0891b2">
                Shruti Pillai — Design Lead
              </option>

              <option value="RJ|Rohan Joshi|Tech Architect|#EC4119">
                Rohan Joshi — Tech Architect
              </option>

            </select>

            <button
              className="btn btn-success btn-sm add-panel-btn"
              onClick={() => addPanel()}
            >
              <i className="fa-solid fa-plus"></i>
            </button>

          </div>

        </div>

      </div>
    </div>


    {/* Same Day Context */}
    <div className="side-card">

      <div className="side-card-header-simple">

        <h4>
          <i className="fa-solid fa-calendar-day side-header-icon-blue"></i>
          Same Day — Jun 26
        </h4>

      </div>


      <div className="same-day-body">

        <div className="same-day-item">
          <div className="sd-time">11:00 AM</div>
          <div className="sd-info">
            Rahul Kumar · R2 HR · Priya Sharma
          </div>
        </div>

        <div className="same-day-item">
          <div className="sd-time">2:00 PM</div>
          <div className="sd-info">
            Amit Kumar · R1 Technical · Rahul Dev + Neha G
          </div>
        </div>

        <div className="same-day-item">
          <div className="sd-time">4:00 PM</div>
          <div className="sd-info">
            Priya Singh · R3 Director · Arun Mishra
          </div>
        </div>


        <div className="same-day-note">
          <i className="fa-solid fa-circle-info"></i>
          3 interviews already today. Check panel availability before scheduling.
        </div>

      </div>
    </div>


    {/* Candidate History */}
    <div className="side-card">

      <div className="side-card-header-simple">

        <h4>
          <i className="fa-solid fa-user-tie side-header-icon-primary"></i>
          Candidate History
        </h4>

      </div>


      <div className="history-body">

        <div className="history-name">
          Rahul Kumar
        </div>

        <div className="history-stage">
          Current stage:{" "}
          <strong>Interview</strong>
        </div>


        <div className="history-list">

          <div className="history-item">

            <span className="history-dot history-dot-green"></span>

            <span>
              R1 Technical —{" "}
              <strong className="history-cleared">
                Cleared
              </strong>{" "}
              — Jun 8
            </span>

          </div>


          <div className="history-item">

            <span className="history-dot history-dot-amber"></span>

            <span>
              R2 HR —{" "}
              <strong className="history-scheduled">
                Scheduled
              </strong>{" "}
              — Jun 26
            </span>

          </div>

        </div>


        <div className="history-note">

          <i className="fa-solid fa-note-sticky"></i>

          "Strong React. Confident communicator. Proceed to HR round."
          — Rahul Dev

        </div>

      </div>
    </div>

  </div>

</div>
      </div>

      {/* Form Footer */}
      <div className="form-footer">
        <button className="btn btn-outline btn-sm" onClick={() => window.history.back()}>Cancel</button>
        <button className="btn btn-secondary btn-sm" onClick={() => toast('Interview saved as draft')}>
          <i className="fa-regular fa-floppy-disk"></i> Save Draft
        </button>
        <button className="btn btn-primary btn-sm" onClick={submitSched}>
          <i className="fa-solid fa-calendar-check"></i> Schedule &amp; Send Invites
        </button>
      </div>
    </>
  );
};

export default ScheduleInterview;